export const animationConfig = {
  delay: 100,
  duration: 300,
};
